import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";


declare var ko: any;
declare var page: any;

export class goalView_template extends vnTemplate {

    
    protected getTemplateHtml(): string {

        return `
        
            <div class="form-header" data-bind="with: goal">
                <input type="hidden">
                <button class="btn secondary icon i-back" data-bind="click: $parent.onClickBackToList" type="button">back to Goal list</button>
                <h3 class="form-title icon i-goal" data-bind="text: brand.name + ' | ' + group.name + ' | ' + initiative.name + ' | ' + displayMonth + ' ' + year"></h3>
                <button class="btn secondary icon i-edit" type="button" data-bind="click: $parent.onClickEdit">Edit Goal</button>
            </div>
            
            <div id="view-results">
            
                 <div data-bind="with: goal">     
                    <div class="w-form-body">
                
                        <div class="form-body">
                            <div class="form-group">
                                 <dl class="double-list">              
                                    <dt>
                                        <span>Brand</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: brand.name"></span>
                                    </dd>
                                    <dt>
                                        <span>Initiative</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: initiative.name"></span>
                                    </dd>
                                    <dt>
                                        <span>Group</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: group.name"></span>
                                    </dd>
                                     <dt>
                                        <span>Year</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: year"></span>
                                    </dd>
                                    <dt>
                                        <span>Month</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: displayMonth"></span>
                                    </dd>
                                </dl>
                            </div>
                              
                         </div>
                         <div class="form-body">
                            <div class="form-group">
                               <dl class="double-list">
                                    <dt>
                                        <span>Articles Count</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: articleCount"></span>
                                    </dd>
                                    <dt>
                                        <span>Sessions Per Article</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: sessionsPerArticle"></span>
                                    </dd>
                                    <dt>
                                        <span>Cost Per Article</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: costPerArticle"></span>
                                    </dd>
                                    <dt>
                                        <span>Creation Date</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: dateCreated"></span>
                                    </dd>
                                                               
                                </dl>
                            </div>
                        </div>
                    </div>
                    
                    <div class="w-form-body">
                        <div class="form-body full-width">
                            <strong class="form-sub-title">Cost Allocation</strong>
                        </div>
                    </div>
                              
                     <div class="w-form-body">
                        <div class="form-body full-width">
                            <table class="list-action view-goal" style="margin-bottom: 2rem">
                                <thead>
                                    <tr>
                                        <th><span>Name</span></th>
                                        <th><span>Amount</span></th>
                                        <th><span>Number Of Article</span></th>
                                    </tr>
                                </thead>   
                                <tbody  data-bind="foreach: costAllocations">
                                    <tr>
                                        <td>
                                            <span data-bind="text: name"></span 
                                        </td>   
                                        <td class="align-center">
                                            <span data-bind="text: amount"></span>
                                        </td>  
                                        <td class="align-center">
                                            <span data-bind="text: nbrArticles"></span>
                                        </td>  
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    protected initPartial() {
    }

    /**
     *
     * @protected
     */
    protected getTemplateName(): string {
        return "goalView_template";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form", "w-form-large", "margin-top", "roles-view"];
    }

    protected buildViewModel(): any {

        let myself = this;
        return {
            idGoal: ko.observable(""),
            goal: ko.observable(),
            onClickBackToList: function () {
                myself.onClickBackToList();
            },
            onClickEdit: function () {
                myself.onClickEdit();
            }
        };
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest(): Object {

        return {
            idGoal : this.getTemplateViewModel().idGoal()
        }
    }

    protected onClickBackToList(): void {

        this.caller.backToList();
    }

    protected onClickEdit(): void {

        this.caller.editGoal(this.getTemplateViewModel().idGoal());
    }

    public setNetworkGroup(goal: {id: number, name: string, networks: Array<{id: number, name: string, description: string}>}): void {

        this.getTemplateViewModel().goal(goal);
    }

    public getGoal() {
        return this.getTemplateViewModel().goal();
    }

    public setGoal(goal): void {
        this.getTemplateViewModel().goal(goal);
    }

    protected onUpdateError(status, data): void {
        console.log('onUpdateError' + status);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/goalView_template.ts